import { cn } from "@/infrastructure/adapters/classnames";
import { IDeductionChip, PriorityKey } from "./IDeductionChips";
import { getAgeChipClassName } from "./DeductionChipUtils";
import { DeductionChip } from "./DeductionChip";

interface AgeChipProps extends IDeductionChip {
  priorityKey: PriorityKey;
  age: number;
  isClosed?: boolean;
}

export const AgeChip = ({
  priorityKey,
  age,
  isClosed = false,
  iconSize,
  withBorder = true,
  withBackground = false,
  size = "small",
  style,
  className,
  shape = "square",
}: AgeChipProps) => {
  if (!age || (!isClosed && !priorityKey)) {
    return null;
  }

  const classNames = cn(
    getAgeChipClassName(priorityKey, withBorder, withBackground, isClosed),
    "priority-chip",
    className
  );

  return (
    <DeductionChip
      icon={undefined}
      size={size}
      iconSize={iconSize}
      shape={shape}
      style={style}
      className={classNames}
      label={`${age}d`}
    />
  );
};
